import { Badge } from "@fox1ck-org/ui";
import { ConversionStatus } from "@gen/tracker/v1/conversion_pb";

import { conversionStatusText, conversionStatusTone } from "@/lib/services/conversion-service";

/**
 * The status of a conversion as every screen draws it (доски CConversions,
 * Conversions): the package's `Badge` with its dot, in the tone of the
 * outcome.
 */
export function ConversionStatusBadge({ status, className }: { status: ConversionStatus; className?: string }) {
  return (
    <Badge variant={conversionStatusTone(status) ?? "neutral"} dot className={className}>
      {conversionStatusText(status)}
    </Badge>
  );
}
